import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {PageMetaService} from '../../common/services/page-meta/page-meta.service';
import {HeroSectionComponent} from "./sections/hero-section/hero-section.component";
import {ContributorsSectionComponent} from "./sections/contributors-section/contributors-section.component";

@Component({
  selector: 'app-about-page',
  template: `
    <app-hero-section/>
    <app-contributors-section/>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeroSectionComponent,
    ContributorsSectionComponent
  ],
  standalone: true
})
export class AboutPageComponent {


  constructor(private pageMetaService: PageMetaService) {
    this.pageMetaService.setTitleAndDescription({
      title: `About Car for Ukraine Volunteering Initiative`,
      description: `At the Volunteering Initiative Car for Ukraine, we accept, upgrade, and deliver donated vehicles to the frontlines in Ukraine.`
    });
  }
}

export default AboutPageComponent;
